import { TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { Grid,Box,Typography, Paper } from '@mui/material';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import NumberField from '../../../components/FormField/NumberField';
import { pattern } from '../../../components/Pattern/Pattern';
import IFSCField from '../../../components/FormField/IFSCField';

const BankDetails = () => {
    const { control, setValue ,watch, clearErrors, trigger} = useFormContext();
    // Inside your component
    const accountNumber = useWatch({ control, name: 'accountNumber' });
    const ifscCode = useWatch({ control, name: 'ifscCode' });
    const beneficiaryName = useWatch({ control, name: 'beneficiaryName' });
    const bankName = useWatch({ control, name: 'bankName' });
    // Check if any bank field has value
    const hasBankData = accountNumber || bankName || ifscCode || beneficiaryName;

    // Clear errors and re-validate when dependency fields change
    useEffect(() => {
        if (!hasBankData) {
            // Clear all bank field errors when no bank data is present
            clearErrors(['beneficiaryName', 'accountNumber', 'ifscCode', 'bankName']);
        } else {
            // Re-validate all fields when bank data is present
            trigger(['beneficiaryName', 'accountNumber', 'ifscCode', 'bankName']);
        }
    }, [hasBankData, clearErrors, trigger]);
  return (
    // <Grid item lg={6} xs={12}>
        <Paper>
        <Box sx={{ p: '.5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
            <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>Bank Info</Typography>
        </Box>
        <Grid container spacing={1} sx={{ padding: '2%' }}>
            <Grid item xs={12}>
                <Typography sx={{ fontSize: '.75rem', fontWeight: '600' }}>A/C Holder Name</Typography>
                <Controller
                    name="beneficiaryName"
                    control={control}
                    defaultValue=""
                    rules={{
                        required: (accountNumber||bankName||ifscCode) ? 'Enter Account Holder Name' : false,
                        pattern:pattern.businessName
                    }}
                    render={({ field ,fieldState:{error}}) => (
                    <TextField
                        {...field}
                        fullWidth
                        sx={{}}
                        size='small'
                        InputProps={{
                            style: {
                                // height:'2rem',
                            },
                            inputProps: {
                                style: {
                                    fontSize: '.75rem'
                                },
                            }
                        }}
                        error={!!error}
                        helperText={error && error?.message}
                    />
                    )}
                />
            </Grid>
            <Grid item lg={6} xs={12}>
                <Typography sx={{ fontSize: '.75rem', fontWeight: '600' }}>Account Number</Typography>
                    <NumberField
                        name="accountNumber"
                        control={control}
                        defaultValue=""
                        rules={{
                            // required:'Empty not allowed'
                            required: (bankName||ifscCode||beneficiaryName) ? 'Enter Account Number' : false,
                            pattern : pattern.bankAccountNumber
                        }}
                        size='small'
                        InputProps={{
                            style: { fontSize: '0.75rem' },
                            onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                            onKeyDown: (e) => {
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                }
                            }
                        }}
                        allowNegative={false}
                        // min
                        // max
                        // digits='10'
                        // decimalPlaces
                        errorText={true}
                        // disabled
                        preserveLeadingZeros={true}
                    />
            </Grid>
            <Grid item lg={6} xs={12}>
                <Typography sx={{ fontSize: '.75rem', fontWeight: '600' }}>Bank IFSC Code</Typography>
                {/* <Controller
                    name="ifscCode"
                    control={control}
                    defaultValue=""
                    rules={{
                        // required:'Empty not allowed'
                        pattern:pattern.bankIfscCode
                    }}
                    render={({ field ,fieldState:{error}}) => (
                    <TextField
                        {...field}
                        fullWidth
                        sx={{}}
                        size='small'
                        InputProps={{
                        style: {
                            // height:'2rem',
                        },
                        inputProps: {
                            style: {
                                fontSize: '.75rem'
                            },
                        }
                        }}
                        error={!!error}
                        helperText={error && error?.message}
                    />
                    )}
                /> */}
                <IFSCField
                    name="ifscCode"
                    control={control}
                    rules={{ 
                        // required: watch('accountNumber') ? 'IFSC code is required':true 
                        required: (accountNumber||bankName||beneficiaryName) ? 'Enter IFSC Code' : false
                    }}
                    // label="IFSC Code"
                    placeholder="Enter IFSC Code (e.g., SBIN0001234)"
                    validateOnChange={true}
                    apiProvider="razorpay" // Free, no API key needed
                    onIfscValidation={(bankName)=>setValue('bankName', bankName)}
                    errorText={true}
                    // watch={watch}
                />
            </Grid>
            <Grid item xs={12}>
                <Typography sx={{ fontSize: '.75rem', fontWeight: '600' }}>Bank Name</Typography>
                <Controller
                    name="bankName"
                    control={control}
                    defaultValue=""
                    rules={{
                        // required:'Enter Bank Name'
                        required: (accountNumber||ifscCode||beneficiaryName) ? 'Enter Bank Name' : false,
                        pattern: pattern.bankName
                    }}
                    render={({ field ,fieldState:{error}}) => (
                    <TextField
                        {...field}
                        disabled
                        fullWidth
                        sx={{}}
                        size='small'
                        InputProps={{
                            style: {
                                // height:'2rem',
                            },
                            inputProps: {
                                style: {
                                    fontSize: '.75rem'
                                },
                            }
                        }}
                        error={!!error}
                        // helperText={error && error?.message}
                    />
                    )}
                />
            </Grid>
        </Grid>
        </Paper>
    // </Grid>
  )
}

export default BankDetails
